import { PlanAccessType } from 'Features/OperationalPlanner/OperationalPlanner.types'

export const WORKCENTRE_STATUS = {
  INITIATED: 'INITIATED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  UNSTARTED: 'UNSTARTED',
  RUNNING: 'RUNNING',
  PUBLISHED: 'PUBLISHED',
}

export const PLAN_STATUS = {
  INITIATED: 'INITIATED',
  SUCCESS: 'SUCCESS',
  PLAN_DATA_LOADED: 'PLAN_DATA_LOADED',
  RUNNING: 'RUNNING', // When we click Run after PLAN_DATA_LOADED
  DELETING: 'DELETING',
  CLONING: 'CLONING',
  BEING_CLONED: 'BEING_CLONED',
  FAILED: 'FAILED',
  LOCKING: 'LOCKING',
  UN_LOCKING: 'UN LOCKING',
  SET_READ_ONLY: 'MAKING READ ONLY',
  UN_SET_READ_ONLY: 'MAKING EDITABLE',
}

export const PLAN_ACCESS_TYPE = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  SHARED: 'shared',
}

export const PLAN_EDIT_MODES = {
  READ_ONLY: 'read_only',
}

export const DISPLAY_MODES = {
  DASHBOARD: 'DASHBOARD',
  PLANNING_BOOK: 'PLANNING_BOOK',
}

export const WORKCENTRE_STATUS_FETCH_TIMEOUT = 1000 * 60

export const PLAN_STATUS_FETCH_TIMEOUT = 1000 * 60

export const PLAN_ACCESS_OPTIONS = {
  'Generated by me': 'Generated by me',
  'Not generated by me': 'Not generated by me',
  'Generated by anyone': 'Generated by anyone',
}

export const defaultPlanAccessType: PlanAccessType = {
  planAccessType: PLAN_ACCESS_TYPE.PUBLIC,
  readonly: false,
}

export const OPERTAUIONAL_PLAN_STATUS = {
  INITIATED: 'INITIATED',
  SUCCESS: 'SUCCESS',
  PLAN_DATA_LOADED: 'PLAN_DATA_LOADED',
  RUNNING: 'RUNNING',
  DELETING: 'DELETING',
  CLONING: 'CLONING',
  BEING_CLONED: 'BEING_CLONED',
  FAILED: 'FAILED',
  LOCKING: 'LOCKING',
  UN_LOCKING: 'UN LOCKING',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  APPROVED: 'APPROVED',
}
